import { CodeBracesIcon } from './CodeBracesIcon';

/**
 * author: Simran
 * id 1F6661BC-6538-4EF0-92B5-46EFAE5E0C77
 * name code-braces
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/code-braces.svg
 * tags
 * - Developer / Languages 
 * - Math 
 */
export const SetIcon = CodeBracesIcon;
export default SetIcon